import React, { useEffect, useState } from "react";
// import { Col, Row, Radio, Input, Checkbox, Form, Button } from "antd";
// import { getStyleProperties } from "../../../utils/CustomFunc";
import ExamResult from "./ExamResult";
import ExamOTP from "./ExamOTP";
import "./exam.css";
import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import ExamZenForm from "./ExamZenForm";

const ExamDetailZF = (props) => {
  props.setPageHeader("Attend Exam");
  const [pageConfig, setPageConfig] = useState();
  const onFinish = (values) => {

  };
  const [examDetail, setExamDetail] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [result, setResult] = useState({ displayResult: false, result: null });
  const [loginError, setLoginError] = useState(false);

  const resultCallBack = (values) => {
    liracrypt
      .post("/exams/submitanswers?", values)
      .then(({ data }) => {
        setResult({ displayResult: true, result: data.data });
      })
      .catch(function (error) {
        // message.error('ERROR: Unable to save!', 4);
        console.log("Error****:");
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  const backToExam = () => {
    setExamDetail(null);
    setResult({ displayResult: false, result: null });
  };

  const formSubmitHandler = (values) => {
    liracrypt
      .get("/textapi", {dn: 'examZenForm', command: "fetch_questions", otp: values["OTP"] })
      .then(({ data }) => {
        setPageConfig(data);
        // if (data) {
        //   let newExamDetai = { ...data.data };
        //   const newData = data.data.questions.map((qes) => {
        //     return {
        //       _id: qes["_id"],
        //       Lang: qes["lang"],
        //       Typ: qes["typ"],
        //       Qst: qes["qst"],
        //       option: [
        //         { key: "A", value: qes["A"] },
        //         { key: "B", value: qes["B"] },
        //         { key: "C", value: qes["C"] },
        //         { key: "D", value: qes["D"] },
        //       ],
        //     };
        //   });
        //   newExamDetai["Data"] = newData;
        //   setExamDetail(newExamDetai);
        // }
      })
      .catch(function (error) {
        setErrorMsg(
          error &&
            error.response &&
            error.response.data &&
            error.response.data.message
            ? error.response.data.message
            : "Invalid Otp!!!"
        );
        console.log("Error****:", error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            // ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  return (
    <>
      <SessionError visible={loginError} />
      <React.Fragment>
        <div className="exam">
          {!pageConfig ? (
            <ExamOTP
              formSubmitHandler={formSubmitHandler}
              errroMsg={errorMsg}
            />
          ) : result.displayResult ? (
            <ExamResult result={result.result} backToExam={backToExam} />
          ) : (
            <ExamZenForm pageConfig={pageConfig} questions={pageConfig?.data} submitHandler={resultCallBack} />
          )}
        </div>
      </React.Fragment>
    </>
  );
};
export default ExamDetailZF;
